module.exports = __webpack_public_path__ + "static/media/8-5.bc8734ae.mp3";